module.exports = __webpack_public_path__ + "img/feed_reload.da1ac0e4.svg";